import { request } from "../utils/request.js"

export const supplierBalanceDetail_findPageBySupplier = (pojo, args) => request({
    url: 'supplierBalanceDetail/findPageBySupplier',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const supplierBalanceDetail_findById = (id, args) => request({
    url: 'supplierBalanceDetail/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})



// WEBPACK FOOTER //
// ./src/api/supplierBalanceDetail.js